import { SurveyType } from '@purespectrum1/ui/marketplace/shared/interfaces/survey.interface';
import { SurveyListing } from 'src/app/shared/services/buyer-api/survey.interface';
import { SurveyClassifier } from '@purespectrum1/ui';

export type WidgetSurveyType = Exclude<SurveyType, 'mc'> | 'tc';
export type WidgetInfo = {
  image: string;
  type: WidgetSurveyType;
};

export class SurveyWidgetHelper {
  constructor(private readonly _survey: SurveyListing) {}

  public type(): WidgetSurveyType {
    if (
      SurveyClassifier.fromResponse(this._survey).trackerParent() &&
      this._survey?.trackerCount
    ) {
      return 'tracker';
    }

    if (!!this._survey?.tc_count) {
      return 'tc';
    }

    if (SurveyClassifier.fromResponse(this._survey).groupMcParent()) {
      return 'group-mc';
    }

    if (SurveyClassifier.fromResponse(this._survey).groupedParent()) {
      return 'grouped';
    }

    return 'standard';
  }

  public image(): string {
    switch (this.type()) {
      case 'tracker':
        return 'assets/img/widgets/tracker.png';
      case 'tc':
        return 'assets/img/widgets/trafficChannels.svg';
      case 'group-mc':
        return 'assets/img/widgets/multiCountry.svg';
      case 'grouped':
        return 'assets/img/widgets/group-survey.png';
      default:
        return '';
    }
  }

  public info(): WidgetInfo {
    return {
      image: this.image(),
      type: this.type(),
    };
  }
}
